
import { Checkbox, Dropdown, Menu, Typography } from 'antd';
import React, { useState } from 'react';
import styled from 'styled-components';
import GlobalButton from './GlobalButton';
import {
  TertiaryColor, maxWidth, minWidthApp, primaryColor,
  primaryFont, retina, scrollbar, wMedium
} from 'constants/utilsStyles';
import GlobalSearchBar from './GlobalSearch';
import PersonalityBulletWidget from './PersonalityBulletWidget';
import { DropDownIconsType } from './ToggleFilterButtonGlobal';

const { Paragraph } = Typography;

const Wrapper = styled.div`
`;

const DropDownDiv = styled(Menu)`
  padding: 10px;
  border-radius: 6px;
  .ant-dropdown-menu{
   padding: 15px 10px;
  }
  .select-text-style {
    font-size: 16px;
    line-height: 18px;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    color: ${primaryColor};
    margin-left: 5px;
    cursor: pointer;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 14px;
      line-height: 16px;
    }
  } 
  .global-search-wrapper {
    .global-search-field {
      max-width: 250px;
      width: 100%;
      height: 34px;
      .ant-input-prefix {
        svg {
          width: 18px;
          height: 18px;
        }
      }
      .ant-input {
        font-size: 14px;
        ::placeholder {
          font-size: 14px;
        }
      }
      @media all and (max-width: ${maxWidth}), ${retina} {
        height: 30px;
        .ant-input-prefix {
          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
      @media all and (max-width: ${minWidthApp}) {
        height: 28px;
        .ant-input-prefix {
          svg {
            width: 14px;
            height: 14px;
          }
        }
        .ant-input {
          font-size: 12px;
          ::placeholder {
            font-size: 12px;
          }
        }
      }
    }
  }
  .items-div {
    max-height: 150px;
    min-width: 120px;
    max-width: 250px;
    border-right: none;
    ${scrollbar};
    .ant-menu-item {
      padding: 0px 0px 0px 5px;
      height: 30px;
      margin-bottom: 0px;
      &.ant-menu-item-selected {
        background-color: #fff;
      }
    }
    .dropdown-item-filter {
      display: flex;
      align-items: center;
      padding: 0px;
      cursor: pointer;
      .ant-checkbox-wrapper {
        height: 36px;
      }
      .personality-bullet-widget {
        margin-left: 8px;
        .title {
          font-size: 16px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            font-size: 14px;
          }
        }
      }
      .item-text {
        font-family: ${primaryFont};
        font-weight: ${wMedium};
        font-size: 16px;
        line-height: 18px;
        color: ${TertiaryColor};
        margin-left: 10px;
        margin-bottom: 0px;
        margin-top: 3px;
        &:hover {
          color: ${primaryColor};
        }
        @media all and (max-width: ${maxWidth}), ${retina} {
          font-size: 14px;
          line-height: 16px;
        }
      }
  }
}
`;

export type KeyValueFilterObject = {
  name: string,
  value: string,
  color?: string
}

type Props = {
  title?: string,
  btnData?: DropDownIconsType,
  activeBtnData?: DropDownIconsType,
  selectedFiltersBtnData?: DropDownIconsType,
  dropDownData?: object,
  personality?: boolean,
  hideSearchBar?: boolean,
  data: KeyValueFilterObject[],
  selectAll?: boolean,
  handleSelectAll?: (value: boolean) => void,
  loading?: boolean,
  selectedFilters?: string[],
  onClickCheckBox?: (value: string, add: boolean) => void,
  handleSearchProps?: (value: string) => void,
  clearSearchProps?: () => void,
} & typeof defaultProps;

const defaultProps = {
  title: '',
  btnData: {} as DropDownIconsType,
  activeBtnData: {} as DropDownIconsType,
  dropDownData: {},
  selectedFiltersBtnData: {},
  onClickBtn: () => { },
  personality: false,
  hideSearchBar: false,
  data: [
    { name: 'test1', value: 'test1' },
    { name: 'test2', value: 'test2' },
    { name: 'test3', value: 'test3' },
  ] as KeyValueFilterObject[],
  selectedFilters: ['Test'],
  loading: false,
  onClickCheckBox: (value: string, add: boolean) => { },
  handleSearchProps: (value: string) => { },
  clearSearchProps: () => { },
};

const DropDownButtonGlobal = function DropDownButtonGlobal(props: Props) {
  const { btnData,
    data,
    dropDownData,
    title,
    personality,
    hideSearchBar,
    activeBtnData,
    selectedFiltersBtnData,
    selectAll,
    handleSelectAll,
    loading,
    onClickCheckBox,
    selectedFilters,
    clearSearchProps,
    handleSearchProps,
  } = props;
  const [openDropDown, setOpenDropDown] = useState(false);
  const onOpenChange = () => {
    setOpenDropDown(!openDropDown);
  };

  function handleCheckedNew(value: string) {
    const checked = selectedFilters.includes(value);
    if (checked) {
      onClickCheckBox(value, false);
    } else {
      onClickCheckBox(value, true);
    }
  }

  const menu = (
    <DropDownDiv className='dropdown-div' >
      {hideSearchBar ? null : (
        <>
          {personality ? (
            <span
              className='select-text-style'
              onClick={() => handleSelectAll && handleSelectAll(!selectAll)}
            >{selectAll ? 'Unselect All' : 'Select All'}</span>
          ) : (
            <GlobalSearchBar placeholderProps={title} searchIcon handleSearchProps={handleSearchProps} clearSearchProps={clearSearchProps} />
          )}
        </>
      )}
      {loading ? 'Loading...' : <Menu className='items-div'>
        {data.map((item) => (
          <Menu.Item key={item.value}>
            <span className='dropdown-item-filter' onClick={() => handleCheckedNew(item.value)} >
              <Checkbox
                checked={selectedFilters.includes(item.value)}
              />
              {personality ? (
                <PersonalityBulletWidget
                  title={item.name}
                  color={item.color ?? "red"}
                />
              ) : (
                <Paragraph className='item-text text-truncate ' ellipsis={{ rows: 1, tooltip: item?.name }}>{item?.name}</Paragraph>
              )}
            </span>
          </Menu.Item>
        ))}
      </Menu>}
    </DropDownDiv>
  );

  return (
    <Wrapper className='drop-down-btn-global-wrapper'>
      <Dropdown
        overlay={menu}
        placement='bottomLeft'
        trigger={['click']}
        overlayClassName="filter-dropdown"
        getPopupContainer={(e) => e}
        onOpenChange={() => onOpenChange()}
      >
        <GlobalButton
          title={title}
          globalButtonData={openDropDown ? activeBtnData : selectedFilters.length > 0 ? selectedFiltersBtnData : btnData}
          btnClassName='dropdown-global-btn'
        />
      </Dropdown>
    </Wrapper >
  );
};
DropDownButtonGlobal.defaultProps = defaultProps;
export default DropDownButtonGlobal;